<template>
	<van-cell class="preview_input" v-if="isPreview" :title="title" :value="modelValue"></van-cell>
	<van-field
		class="preview_input"
		v-else
		:label="title"
		v-model="modelValue"
		:placeholder="placeholder"
		:maxlength="maxlength"
		:input-align="inputAlign"
	/>
</template>

<script>
	// 带有预览模式的input
	export default {
		name: 'PreviewInput',
		props: {
			showBorder: {
				type: Boolean,
				default: false
			},
			value: {
				type: [String, Number],
				default: ''
			},
			title: {
				type: String,
				default: ''
			},
			isPreview: {
				type: [Boolean, String],
				default: false
			},
			placeholder: {
				type: String,
				default: '请输入'
			},
			maxlength: {
				type: [String, Number],
				default: 500
			},
			inputAlign: {
				type: String,
				default: 'right'
			}
		},
		computed: {
			modelValue: {
				get () {
					return this.value
				},
				set (val) {
					if (typeof val === 'string') {
						val = val.trim()
					}
					this.$emit('input', val)
				}
			}
		}
	};
</script>

<style lang="less">
	.cell_text {
		height: 42px;
		font-size: 30px;
		line-height: 42px;
	}
	.preview_input {
		padding: 35px 28px;
		.van-cell__title {
			font-family: PingFangSC-Medium;
			.cell_text();
			font-weight: 500;
			color: #1F2329;
		}
		.van-cell__value {
			color: #1F2329;
			font-size: 30px;
		}
		.van-field__control {
			font-family: PingFangSC-Regular;
			.cell_text();
		}
		.van-icon-arrow {
			.cell_text();
			color: #BBBFC4;
		}
	}
</style>
